import { useSelector } from 'Flux/index.js'
import type { State } from 'Flux/Slice/index.js'
import { orderSlice } from 'Flux/Slice/Order/OrderSlice.js'
import type { ReprocessingGrantStatus } from '../../../../Generated/ReprocessingGrantStatus.ts'

const selectReprocessingGrant = (state: typeof State) => state[orderSlice.name].reprocessingGrant

export const useGetReprocessingGrantSelector: () => ReprocessingGrantStatus | null = () => useSelector(selectReprocessingGrant)
